import { render, staticRenderFns } from "./SalesmanRole.vue?vue&type=template&id=22904e89&scoped=true"
import script from "./SalesmanRole.vue?vue&type=script&lang=js"
export * from "./SalesmanRole.vue?vue&type=script&lang=js"
import style0 from "./SalesmanRole.vue?vue&type=style&index=0&id=22904e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22904e89",
  null
  
)

export default component.exports